import { assign, cloneDeep } from 'lodash-es'
import type { AppState } from '@/store/modules/app/types'

const baseState = {
  theme: 'light',
  colorWeak: false,
  navbar: true,
  menu: true,
  topMenu: false,
  hideMenu: false,
  menuCollapse: false,
  footer: false,
  themeColor: '#165DFF',
  menuWidth: 310,
  globalSettings: false,
  device: 'desktop',
  tabBar: false,
  menuFromServer: false,
  // serverMenu: [],
}

const useAppStore = defineStore('app', () => {
  const appState = ref<AppState>(cloneDeep(baseState))
  const appDevice = computed(() => appState.value.device)

  function updateSettings(setting: Partial<AppState>) {
    assign(appState.value, setting)
  }

  function toggleTheme(dark: boolean) {
    if (dark) {
      appState.value.theme = 'dark'
      document.documentElement.classList.add('dark')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-6', '106, 185, 163')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-5', '54, 156, 127')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-7', '54, 156, 127')
    }
    else {
      appState.value.theme = 'light'
      document.documentElement.classList.remove('dark')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-6', '61, 100, 231')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-5', '93, 131, 236')
      document
        .querySelector('body')
        ?.style.setProperty('--primary-7', '38, 69, 192')
    }
  }

  function toggleDevice(device: string) {
    appState.value.device = device
  }

  function toggleMenu(value: boolean) {
    appState.value.hideMenu = value
  }

  return {
    appState,
    appDevice,

    updateSettings,
    toggleTheme,
    toggleDevice,
    toggleMenu,
  }
})

export default useAppStore
